//=============================================================================
//                       <--- Developed By Icon Team ---> 18 January 2021
//=============================================================================

// npm packages
import React, { useState, useEffect, useContext, useCallback } from "react";
import context from "context/context";
import { toast } from "react-toastify";
import access from "config/access";
// custom pages
import Table from "components/Table/Table";
import ApprovalAPI from "apis/approval/approval";
import useDebounce from "helpers/useDebounce";
import { styles } from "./styles";
import Loader from "components/Loader/Loader";
import History from "./History";
import { CSVLink } from 'react-csv';
import * as moment from "moment";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import InputAdornment from "@material-ui/core/InputAdornment";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Card from "@material-ui/core/Card";
import Dialog from "@material-ui/core/Dialog";

// material-ui icons
import Grid from "@material-ui/core/Grid";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import SearchOutlinedIcon from "@material-ui/icons/SearchOutlined";
import { blockInvalidChar } from "helpers/blockInvalidChar";
import { useTranslation } from 'react-i18next';
import { exportapprovalHeaders } from "./export";

// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      "&.MuiOutlinedInput-root": {
        marginTop: 0,
        borderRadius: 20,
      },
    },
  },
})(TextField);

export default function Approval() {
  const { state, dispatch } = useContext(context);
  const { getApprovals, update, search,approvalexport } = ApprovalAPI();
  const classes = styles();

  const [data, setData] = useState([]);
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [filterCard, setFilterCard] = useState(false);
  const [searchValue, setSearchValue] = useState(null);
  const searchBounceValues = useDebounce(searchValue);
  const [history, setHistory] = useState(false);

  // dialog
  const [declineDialog, setDeclineDialog] = React.useState(false);
  const [dialogData, setDialogData] = React.useState({});

  const { t, i18n } = useTranslation();
  const [exportData, setExportData] = useState([]);

  const [states, setstates] = useState({
    filter: false,
    filterTier: "",
    filterAppliedTier: "",
    tier: [],
    max_merch_cron_job: "",
    editId: "",
    isEdit: false,
    loyalty_id: "",
    sales_summary_tier: "",
    max_merch_tier: "",
  });

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  const handleExport = async () => {
    // let values = {};
    // let values = {};
    if (searchValue) {
      values = { ...values, searchValue };
    }
    // setLoading(true)
    let values;
    values = {
        searchValue,

        
    };

    dispatch({ type: "SET_LOADING", payload: true });
    let res = await approvalexport(values);
    console.log(res,"ragav")
    if (res && res.data) {
        // setIsLoading(false);
        setExportData(res.data);
        dispatch({ type: "SET_LOADING", payload: false });
       
        if (res.data.length === 0) {
          toast.success(t("No Data Found"), { toastId: "no-report-date" });
          return false;
        }
       
        return true;
      }
    }

  // for breadcrumb
  useEffect(() => {
    dispatch({ type: "SET_PATHNAME", payload: ["HOME", "ADMIN", "Approval"] });
  }, []);

  // handling api calls
  useEffect(() => {
    searchValue && searchValue.length > 0 ? handleSearch() : handleGet();
  }, [offset]);

  // // handling search api
  useEffect(() => {
    if (searchBounceValues && searchBounceValues.length > 0) {
      handleSearch();
    } else {
      setOffset(1);
    }
  }, [searchBounceValues]);

  // change pagination func
  const handlePagination = (value) => {
    setOffset(value);
  };

  // authorized members api func
  const handleGet = async () => {
    try {
      let values;
      values = {
        offset: (offset - 1) * 10,
        limit: 10,
      };
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await getApprovals(values);
      if (res) {
        setData(res.data);
        setCount(res.count);
        dispatch({ type: "SET_LOADING", payload: false });
      }
    } catch (e) {
      console.log({ e });
    }
  };

  // search api func
  const handleSearch = async () => {
    setStates({ filter: false, filterTier: "", filterAppliedTier: "" });
    try {
      let values;

      if (!searchValue.replace(/\s/g, "").length) {
        return;
      }
      values = {
        search: searchValue,
        offset: (offset - 1) * 10,
        limit: 10,
      };
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await search(values);
      if (res) {
        setData(res.data);
        setCount(res.count);
        dispatch({ type: "SET_LOADING", payload: false });
        return;
      }
      dispatch({ type: "SET_LOADING", payload: false });
      setData([]);
    } catch (e) {
      console.log({ e });
    }
  };

  // search api func
  const handleApprove = async (type, id, index) => {
    try {
      let obj = {
        id,
        type,
      };
      let res = await update(obj);
      if (res?.type == "success") {
        setData([...data.slice(0, index), ...data.slice(index + 1)]);
        toast.success("Approved successfully", {
          toastId: "approve-success",
        });
      }
    } catch (e) {
      console.log({ e });
    }
  };

  const handleDecline = async () => {
    try {
      let obj = {
        id: dialogData.id,
        type: dialogData.type,
        decline_reason: dialogData.decline_reason,
      };
      let res = await update(obj);
      if (res.type == "success") {
        toast.success("Declined Request", {
          toastId: "approve-success",
        });
        setData([
          ...data.slice(0, dialogData.index),
          ...data.slice(dialogData.index + 1),
        ]);
      }
      setDeclineDialog(false);
      setDialogData({});
    } catch (e) {
      console.log({ e });
    }
  };

  function goBack() {
    setHistory(false);
  }

  return (
    <React.Fragment>
      {!history && (
        <div>
          <Grid container className={classes.root}>
            <Grid xs={12} sm={12} lg={12} className={classes.topGrid}>
              <CssTextField
                id="loyalty-id"
                placeholder={t('Search for Customer Account Number')}
                type={"number"}
                onKeyDown={blockInvalidChar}
                variant="outlined"
                autoComplete="off"
                className={classes.searchInput}
                  onWheel={(e) => e.target.blur()}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {searchValue && searchValue.length > 0 ? (
                        <CloseOutlinedIcon
                          className={classes.searchInputIcon}
                          onClick={() => {
                            setSearchValue("");
                            setOffset(1);
                            handleGet();
                          }}
                        />
                      ) : (
                        <SearchOutlinedIcon
                          className={classes.searchInputIcon}
                        />
                      )}
                    </InputAdornment>
                  ),
                }}
                value={searchValue}
                onChange={(e) => {
                  setSearchValue(e.target.value);
                  if (e.target.value.length == 0) {
                    handleGet();
                  }
                }}
                onClick={() => {
                  setOffset(1);
                }}
              />
              <Button
                className={classes.historyBtn}
                onClick={() => setHistory(true)}
              >
                {t('View History')}
              </Button>
              <CSVLink
            id="csv"
            data={exportData.map(item => ({
              ...item,
              ['One_Web_Request.type']: [ 'item.One_Web_Request.type'] ? "Enrollment" : "Transfer"
            }))}
             headers={exportapprovalHeaders}
         filename={
              `Approval` +
              " " +
              moment(new Date()).format("MM-DD-YYYY,h:mm A") +
              ".csv"
            }
            className={classes.CSVlink}
          />
                <button
            // disabled={isLoading}
            className={classes.exportBtn1}
            onClick={async () => {
              let res = await handleExport();
              if (res) {
                
                document.getElementById("csv").click();
              }
            }}
          >
            {t('Export')}
          </button>
            </Grid>
            
          </Grid>

          {filterCard && (
            <div className={classes.filterCardDiv}>
              <Grid container spacing={0}>
                <Grid item xs={12} style={{ float: "right" }}>
                  <Card className={classes.filterCard}>
                    <Grid
                      container
                      spacing={1}
                      className={classes.filterCardGridContainer}
                    >
                      <Grid
                        item
                        xs={4}
                        className={classes.filterCardGrid}
                        style={{ padding: "5px 10px 10px 15px" }}
                      >
                        <TextField
                          id={"tier"}
                          label={"Tier"}
                          select
                          fullWidth
                          type={"text"}
                          value={states.filterTier}
                          onChange={(e) => {
                            setStates({ filterTier: e.target.value });
                          }}
                        >
                          {states.tier.length > 0 &&
                            states.tier.map((t, i) => (
                              <MenuItem value={t.tier} key={i}>
                                {t.tier}
                              </MenuItem>
                            ))}
                        </TextField>
                      </Grid>
                      <Grid
                        item
                        xs={4}
                        className={classes.filterCardGrid}
                        style={{ padding: "5px 10px 10px 10px" }}
                      >
                        <TextField
                          id={"applied-tier"}
                          label={"Applied Tier"}
                          select
                          fullWidth
                          type={"text"}
                          value={states.filterAppliedTier}
                          onChange={(e) => {
                            setStates({ filterAppliedTier: e.target.value });
                          }}
                        >
                          <MenuItem value={"Sales"}>{t('Sales')}</MenuItem>
                          <MenuItem value={"Max Merch"}>{t('Max Merch')}</MenuItem>
                        </TextField>
                      </Grid>
                      <Grid
                        item
                        xs={4}
                        className={classes.filterCardBtnGrid}
                        style={{ padding: 10 }}
                      >
                        <Button
                          className={classes.filterCardApplyBtn}
                          style={{
                            fontSize: 15,
                            height: 35,
                            marginTop: 0,
                          }}
                          onClick={() => {
                            setSearchValue("");
                          }}
                        >
                          {t('Apply')}
                        </Button>
                        {states.filter && (
                          <Button
                            className={classes.filterCardResetBtn}
                            onClick={() => {
                              setStates({
                                filter: false,
                                filterTier: "",
                                filterAppliedTier: "",
                              });
                              setOffset(1);
                              setFilterCard(false);
                              handleGet();
                            }}
                          >
                           {t("Reset")} 
                          </Button>
                        )}
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              </Grid>
            </div>
          )}
          <Loader Loading={state.loading} top={"15%"}>
            <Grid className={classes.tableDownInResponsive}>
              <Grid xs={12} sm={12} lg={12}>
                <Table
                  headings={[
                    "Customer Account Number",
                    "Billing Account Number",
                    "Sales Division Code",
                    "Market Class Code",
                    "Segment Code",
                    "Type",
                    "",
                    "",
                  ]}
                  data={data?.map((p, i) => [
                    p?.["Customer_Account.customer_account_number"],
                    p?.["Customer_Account.customer_billto_account_number"],
                    p?.["Customer_Account.customer_sales_division_code"],
                    p?.["Customer_Account.market_class_code"],
                    p?.["Customer_Account.segment_code"],
                    (p?.["One_Web_Request.type"] &&
                      ((p?.["One_Web_Request.type"] === 1 && t("Enrollment")) ||
                        (p?.["One_Web_Request.type"] === 2 && t("Transfer")))) ||
                      (p?.["type"] &&
                        ((p?.["type"] === 1 && t("Enrollment")) ||
                          (p?.["type"] === 2 && t("Transfer")))),
                    [
                      <div
                        className={classes.approveDiv}
                        aria-disabled={!state?.userInfo?.editAction}
                        onClick={()=> {
                          if(state?.userInfo?.editAction ){
                            handleApprove("Approve", p?.id, i);
                          return;
                          }
                        else{
                          toast.error(state.userInfo?.editAccess)
                        return;
                      }}}
                      >
                       {t('Approve')} 
                      </div>,
                    ],
                    [
                      <div
                        className={classes.declineDiv}
                        aria-disabled={!state?.userInfo?.editAction}
                        onClick={()=> {
                          if(state?.userInfo?.editAction){
                            setDialogData({
                              type: "Decline",
                              index: i,
                              id: p?.id,
                            });
                            setDeclineDialog(true);
                          return;
                        }  else{
                          toast.error(state.userInfo?.editAccess)
                        return;
                      }}}
                      >
                        {t('Decline')}
                      </div>,
                    ],
                  ])}
                  offset={offset}
                  count={
                    (count / 10) % 1 == 0
                      ? Math.floor(count / 10)
                      : Math.floor(count / 10 + 1)
                  }
                  handlePagination={handlePagination}
                />
              </Grid>
            </Grid>
          </Loader>
          {/*Decline Dialog */}
          <Dialog
            onClose={() => {
              setDeclineDialog(false);
              setDialogData({});
            }}
            aria-labelledby="simple-dialog-title"
            open={declineDialog}
            style={{ fontFamily: "Segoe-ui" }}
          >
            <div className={classes.dialogParentDiv}>
              <div className={classes.parentText}> {t('Decline Request')}</div>

              <div className={classes.subParentText}>
               {t('Please fill the reason for declining this request')} 
              </div>
              <div>
                <CssTextField
                  id="enterPassword"
                  label={t("Reason")}
                  type={"text"}
                  autoComplete="off"
                  className={classes.dialogInput}
                  value={dialogData.decline_reason}
                  onChange={(e) => {
                    setDialogData({
                      ...dialogData,
                      decline_reason: e.target.value,
                    });
                  }}
                />
              </div>
              <Grid container spacing={0}>
                <Grid item xs={6}>
                  <Button
                    className={classes.cancelBtn}
                    onClick={() => {
                      setDeclineDialog(false);
                    }}
                  >
                    {t('Cancel')}
                  </Button>
                </Grid>
                <Grid item xs={6} className={classes.proceedBtnGrid}>
                  <Button
                    className={classes.proceedBtn}
                    onClick={() => {
                      if (!dialogData.decline_reason) {
                        return toast.error("Please fill the field", {
                          toastId: "empty-reason",
                        });
                      }
                      handleDecline();
                    }}
                  >
                    {t('Proceed')}
                  </Button>
                </Grid>
              </Grid>
            </div>
          </Dialog>
        </div>
      )}
      {history && (
        <History goBack={goBack} handlePagination={handlePagination} />
      )}
    </React.Fragment>
  );
}
